import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

function Results() {
  const location = useLocation();
  const navigate = useNavigate();
  const resultData = location.state?.resultData;

  if (!resultData) {
    console.log('No result data found, redirecting to home.');
    navigate('/');
    return null;
  }

  console.log('Displaying result data:', resultData);

  // Check if there's an error in the response
  if (resultData.error) {
    return (
        <div className="container">
          <div className="error-message">
            <h2>Oops!</h2>
            <p>{resultData.error}</p>
            <p>Please upload a new photo and try again.</p>
          </div>
        </div>
    );
  }

  const gradeColors = {
    A: '#06cc34',
    B: '#6ebf0b',
    C: '#ffb007',
    D: '#e40d0d',
    E: '#8f0c00',
  };

  const gradeColor = gradeColors[resultData.nutritional_value_grade] || '#007bff';

    const handleBuyClick = () => {
        const encodedItemName = encodeURIComponent(resultData.item);
        window.open(`https://www.amazon.com/s?k=${encodedItemName}&tag=peeel-20`, '_blank');
    };

  return (
      <div className="container">
          <h2>{resultData.item}</h2>

          <div className="grade-display" style={{
              backgroundColor: gradeColor,
              color: '#ffffff',
              fontSize: '80px',
              fontWeight: 'bold',
              width: '100px',
              height: '100px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              margin: '20px auto',
              borderRadius: '50%'
          }}>
              {resultData.nutritional_value_grade}
          </div>

          <div className="friendly-message">
              <p>{resultData.friendly_message}</p>
          </div>

          <div className="share-container" style={{textAlign: 'center', marginTop: '20px', marginBottom: '20px'}}>
              <button onClick={handleBuyClick} className="btn btn-outline-primary">
                  <i className="fas fa-shopping-cart"></i> &nbsp; Buy on Amazon
              </button>
          </div>

          {resultData.warnings && resultData.warnings.length > 0 && (
              <div className="warnings mt-3">
              <h4>Health Notes:</h4>
                  <ul>
                      {resultData.warnings.map((warning, index) => (
                          <li key={index}>{warning}</li>
                      ))}
                  </ul>
              </div>
          )}

          <div className="healthier-alternatives mt-3">
              <h4>Healthier Alternatives:</h4>
              <p>{resultData.healthier}</p>
          </div>

          <div className="nutrition-label mt-5">
              <table className="table table-bordered">
                  <thead>
                  <tr>
                      <td colSpan="3">
                          <h3>Nutrition Facts</h3>
                          <p className="serving-size">Serving Size: 1 serving</p>
                      </td>
                  </tr>
                  <tr>
                      <th></th>
                      <th>Amount</th>
                      <th className="text-center">% DV</th>
                  </tr>
                  </thead>
                  <tbody>
                  {Object.entries(resultData.nutrition_data).map(([key, [value, percent]]) => (
                      <tr key={key}>
                          <td>{key.replace(/_/g, ' ').replace(/total /g, '').replace(/\b\w/g, l => l.toUpperCase())}</td>
                          <td>{value.toLocaleString()}{key.includes('total_calories') ? '' : key.includes('total_fat') || key.includes('total_protein') || key.includes('total_carbs') || key.includes('Fiber') ? 'g' : 'mg'}</td>
                          <td className="text-center">{percent}%</td>
                      </tr>
                  ))}
                  </tbody>
              </table>
          </div>

          <div className="ingredients mt-3">
              <h4>Ingredients:</h4>
              <p>{resultData.ingredients_breakdown.join(', ')}</p>
          </div>

          <div className="other-uses mt-3">
              <h4>Other Uses:</h4>
              <p>{resultData.other_uses}</p>
          </div>

          <div className="weird-fact mt-3">
              <h4>Weird Fact</h4>
              <p>{resultData.weird_fact}</p>
          </div>

          <div className="notice mt-3">
              <h4>Disclaimer</h4>
              <p>Our AI once confused a celery stick for a light saber. For your safety and our legal team's sanity,
                  never trust our app's nutritional advice. Always talk to a qualified healthcare professional and read
                  actual food labels. This app's AI is about as qualified in nutrition as a potato is in astrophysics,
                  nothing on here is medical advice – always consult your doctor for that. This site is for novelty use
                  only.</p>
          </div>
      </div>
  );
}

export default Results;